import React from 'react'
import {Card} from './Card/Card'
import getCardSize from '../../../helpers/getCardSize'
import './Deck.css'
import {CardProps} from '../Game'
import {Deck as DeckUtil} from '../../../utils/Deck/Deck'

type DeckState = {}

type DeckProps = {
    onClick?: Function
    fast?: boolean
    animatedKeys?: string[]
    cards: CardProps[]
    lang: string
}

export class Deck extends React.Component<DeckProps, DeckState> {
    constructor(props: any) {
        super(props)
        this.state = {}
    }

    render(): JSX.Element {
        const {width, height} = getCardSize()
        const {animatedKeys, cards} = this.props

        return (
            <div className="Deck" onClick={e => this.onClick(e)}>
                {cards &&
                    cards.map((cardProps: CardProps, index: number) => {
                        let {key} = cardProps
                        let {left, top, rotate, active, flip, z} = cardProps
                        let {deck} = cardProps
                        let card = DeckUtil.getInstance().getCardByKey(key)
                        return (
                            <Card
                                key={key}
                                data-key={key}
                                rank={card.rank}
                                suit={card.suit}
                                zIndex={index + 1}
                                width={width}
                                height={height}
                                left={left}
                                top={top}
                                rotate={rotate}
                                active={active}
                                flip={flip}
                                deck={Boolean(deck)}
                                z={z}
                                animated={animatedKeys && animatedKeys.indexOf(card.key) !== -1}
                                lang={this.props.lang}
                            />
                        )
                    })}
            </div>
        )
    }

    private onClick(e: React.MouseEvent): void {
        const key = Deck.getKeyByEvent(e)

        if (key && this.props.onClick) {
            this.props.onClick(key)
        }
    }

    private static getKeyByEvent(e: React.MouseEvent): string {
        let target = e.target as HTMLAreaElement

        if (target.className.indexOf('Card ') === -1) {
            target = target.parentNode as HTMLAreaElement
        }
        return target.getAttribute('data-key') as string
    }
}
